module.exports = __webpack_public_path__ + "media/images/fast_application-987a2ff7.svg";